if (!customElements.get('ed-stove-options')) {
  customElements.define('ed-stove-options', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section--product-template');
      if (!this.root) return;
      this.onChange = this.onChange.bind(this);
      this.onNativeChange = () => this.schedule();
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.root, {childList: true, subtree: true});
      this.root.addEventListener('kit:variant-picker:after-change', this.onNativeChange);
      this.reconcile();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('kit:variant-picker:after-change', this.onNativeChange);
      this.fields?.forEach(field => field.remove());
      this.restoreNative();
    }
    schedule() {
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => {this.queued = false; if (this.isConnected) this.reconcile();});
    }
    restoreNative() {
      if (this.wrapper?.isConnected && this.nativeField?.isConnected) this.wrapper.replaceWith(this.nativeField);
      this.wrapper = null;
    }
    reconcile() {
      const picker = this.root.querySelector(`kit-variant-picker[data-product-id="${this.dataset.productId}"]`);
      const native = picker?.querySelector('select[data-option-name="Configuration"]');
      const nativeField = native?.closest('.kit-fieldset');
      if (!nativeField) return;
      if (this.native !== native || !this.fields?.every(field => field.isConnected)) {
        this.fields?.forEach(field => field.remove());
        this.restoreNative();
        const fragment = this.querySelector('template[data-ed-stove-template]')?.content.cloneNode(true);
        if (!fragment) return;
        const fields = [...fragment.querySelectorAll('[data-ed-stove-field]')];
        if (!fields.length) return;
        const wrapper = document.createElement('div'); wrapper.hidden = true;
        nativeField.before(fragment, wrapper); wrapper.appendChild(nativeField);
        this.fields = fields; this.wrapper = wrapper; this.nativeField = nativeField; this.native = native;
        this.controls = fields.map(field => field.querySelector('[data-ed-stove-choice]'));
        const combinations = [...native.options].map(option => option.value.split(' || '));
        this.controls.forEach((control,index) => {
          for (const value of new Set(combinations.map(values => values[index]).filter(Boolean))) {
            const option = document.createElement('option'); option.value = value; option.textContent = value; control.appendChild(option);
          }
          control.addEventListener('change',this.onChange);
        });
      }
      const selected = native.value.split(' || ');
      this.controls.forEach((control,index) => {control.value = selected[index] || '';});
      const available = [...native.options].filter(option => !option.disabled).map(option => option.value.split(' || '));
      this.controls.forEach((control,index) => {
        for (const option of control.options) option.disabled = !available.some(values => values[index] === option.value && values.slice(0,index).every((value,j) => value === this.controls[j].value));
      });
      if (this.focusIndex != null) {this.controls[this.focusIndex]?.focus(); this.focusIndex = null;}
    }
    onChange(event) {
      event.stopPropagation();
      const index = Number(event.target.dataset.edStoveChoice);
      const desired = this.controls.map(control => control.value);
      const available = [...this.native.options].filter(option => !option.disabled);
      let option = available.find(option => option.value === desired.join(' || '));
      if (!option) {
        const candidates = available.filter(option => option.value.split(' || ').slice(0,index+1).every((value,j) => value === desired[j]));
        candidates.sort((a,b) => b.value.split(' || ').filter((value,j) => value === desired[j]).length-a.value.split(' || ').filter((value,j) => value === desired[j]).length);
        option = candidates[0];
      }
      if (!option) {this.reconcile();return;}
      this.focusIndex = index;
      this.native.value = option.value;
      this.native.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });
}

